import React, { useCallback } from 'react'

import { Tooltip } from 'antd'

import { getMessage } from '../../../../../../../util/IntlMessages'

import './PanelHeader.less'

export function PanelHeader({ groupName, fields }) {
  const hasRequiredField = useCallback(() => {
    return fields.some(({ requiredField }) => requiredField)
  }, [fields])

  return (
    <span className="PanelHeader__groupCollapseHeader">
      {groupName}
      {hasRequiredField(fields) && (
        <Tooltip title={getMessage('groupHasMandatoryField')}>
          <span className="PanelHeader__groupCollapseRequired">{' *'}</span>
        </Tooltip>
      )}
    </span>
  )
}
